import { isProd } from '@/constants/Constants';
import _ from 'lodash';

import aegis from './report-rum';
import reportHub from './report-hub';
import beacon from './report-beacon';

export const getPageReportKey = (key) => {
  const { pathname } = window.location;
  const prefix = pathname.replace('/ams/', '').replace('agency/', '');
  return [...prefix.split('/'), key].join('.');
};

export default {
  init: () => {
    window.addEventListener('unhandledrejection', (event) => {
      if (isProd) {
        beacon.onDirectUserAction('unhandledrejection', event);
      }
    });
  },

  setLoginStatus: (loginStatus) => {
    if (loginStatus) {
      aegis.setConfig({
        uin: loginStatus.user_id,
        ext1: loginStatus.bm_id,
        ext2: loginStatus.agency_uid,
      });

      reportHub.setCommonInfo({
        uin: loginStatus.user_id,
        bm_id: loginStatus.bm_id,
        company_id: loginStatus.company_id,
        agency_uid: loginStatus.agency_uid,
        login_type: loginStatus.login_type,
        roles: Object.keys(loginStatus.role_list || {}).join(','),
        real_name_verify_status: loginStatus.real_name_verify_status,
      });

      beacon.addAdditionalParams({
        bm_id: loginStatus.bm_id,
        bm_name: loginStatus.bm_name,
        agency_uid: loginStatus.agency_uid,
        user_id: loginStatus.user_id,
        qq_number: loginStatus.qq_number,
        qq_nickname: loginStatus.qq_nickname,
        wechat_number: loginStatus.wechat_number,
        env: loginStatus.env,
      });
      beacon.setOpenId(loginStatus.user_id);
    }
  },

  setCommonInfo: (info = {}) => {
    reportHub.setCommonInfo(info);
    if (info.agency_uid) {
      aegis.setConfig({
        ext2: info.agency_uid,
      });
    }
  },

  reportAction: (data) => {
    reportHub.reportAction(data);
  },

  reportTime: (key, duration) => {
    aegis.reportTime(key, duration);
  },

  reportCrash: (info = {}) => {
    if (_.isError(info.error)) {
      aegis.error(info.error);
    } else {
      aegis.error({
        msg: `client crash: ${JSON.stringify(info.error)}`,
        trace: info.trace_id,
      });
    }
  },

  reportError: (info = {}) => {
    const { message, ...other } = info;
    aegis.error({
      ...other,
      msg: `error: ${message}`,
    });
  },

  renderHottag: () => {
    reportHub.renderHottag();
  },
};
